export default __webpack_public_path__ + "static/hero-07661a48ac676c6a442687bc40dc17ed.png";